import { GfsAssessmentOverviewPage } from "@/services/backend/gfs/assessment/components/assessment-overview-page";

export default function GfsAssessmentOverviewRoute() {
  return <GfsAssessmentOverviewPage />;
}
